export enum ProductType {
  // This is the order in which services will be displayed
  IP = "IP",
  LightPath = "LightPath",
  L2VPN = "L2VPN",
  L3VPN = "L3VPN",
  Firewall = "FW",
  Wireless = "Wireless",
  Wired = "Wired",
  Port = "Port",
  IPPrefixes = "IP_PREFIX",
  SURFcert = "cert",
  SURFdomeinen = "domains",
  IoTnet = "iotnet",
}

const reverseMapping = Object.values(ProductType).reduce(
  (mapping, type) => {
    mapping[type.valueOf()] = type;
    return mapping;
  },
  {} as Record<string, ProductType>,
);

export function mapToProductType(productType: string): ProductType | undefined {
  const match = reverseMapping[productType];
  if (match === undefined) {
    console.error(`Unknown product type: ${productType}`);
  }
  return match;
}
